module.exports = __webpack_public_path__ + "media/images/shopify_faq_5-6cb29e0db951028218aae5d96502e13c.png";